import React from 'react';
import loaderAnimation from "../assets/lottie-file/Animation - 1710440061575.json";
import Lottie from 'lottie-react';
import "../component/styles/styles.scss";

export default function Loader() {
    return (
        <div className='loader-wrapper'>
            <Lottie
                animationData={loaderAnimation}
                loop
                autoplay
            />
        </div>
    )
}
